import React from 'react';
import PropTypes from 'prop-types';
import { find, get, isEmpty, map } from 'lodash';
import { Cushion, LinearGradient, Rectangle, Space, Typography } from '@pitchero/react-ui';
import Icon from '../icon';
import { Trans } from '../../lib/i18n';
import WebsiteListItem from './website-list-item';

const ClubAccountList = ({ clubs, badgeTotals, onClickBack }) => {
  if (isEmpty(clubs)) {
    return null;
  }

  const clubBadgeTotals = get(badgeTotals, 'clubs', []);

  return (
    <>
      <LinearGradient
        component="div"
        angle={90}
        stops={[
          [0, 'mercury'],
          [100, 'white'],
        ]}
        style={{ flexShrink: 1 }}
      >
        <Cushion vertical="large" horizontal="xlarge">
          <div
            role="button"
            tabIndex={-1}
            onKeyDown={onClickBack}
            onClick={onClickBack}
            style={{ cursor: 'pointer' }}
          >
            <Space right="small">
              <Icon name="back-arrow" size={18} color="black" topOffset={4} />
            </Space>
            <Typography preset="subtitle--small" color="black">
              <Trans i18nKey="common:network_panel.account_link">Your account</Trans>
            </Typography>
          </div>
        </Cushion>
      </LinearGradient>
      <Rectangle fill="white" style={{ flex: 1, overflowY: 'auto' }}>
        <Cushion vertical="large" horizontal="xlarge">
          {map(clubs, (club) => {
            const clubTotals = find(clubBadgeTotals, { club_id: club.id });
            const badgeTotal = clubTotals
              ? clubTotals.membership +
                clubTotals.messages +
                clubTotals.payments +
                clubTotals.schedule
              : 0;
            return (
              <Space vertical="xsmall" key={club.id}>
                <a
                  aria-label={club.name}
                  href={`/token-redirect?url=${encodeURIComponent(club.accountUrl)}`}
                  title={club.name}
                >
                  <WebsiteListItem website={club} badgeTotal={badgeTotal} />
                </a>
              </Space>
            );
          })}
        </Cushion>
      </Rectangle>
    </>
  );
};

ClubAccountList.propTypes = {
  clubs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      accountUrl: PropTypes.string,
      name: PropTypes.string,
    }),
  ).isRequired,
  badgeTotals: PropTypes.shape().isRequired,
  onClickBack: PropTypes.func.isRequired,
};
export default ClubAccountList;
